const honda = (function(){

    const getValidationHondaHome = document.querySelector('.responsability__background');
    const getValidationArticleHome = document.querySelector('.publications__right__element');


    function _hondaResponsability(){

        if(getValidationHondaHome){
            function calcHeightHonda(){
                let getHondaTransparent = document.querySelector('.responsability__background');
                let getImageCometa = document.querySelector('.responsability__container__image');
                getImageCometa.style.height = getHondaTransparent.scrollHeight - 5 + 'px';
            }
    
            calcHeightHonda();
            window.addEventListener('resize', calcHeightHonda);
        }

    }

    function _backgroundPublications(){

        if(getValidationArticleHome){
            function calcHeightArticle(){
                let getAfterElement = document.querySelector('.publications__right__element');
                let getArticleHeight = document.querySelector('.publications__card__block--absolute').scrollHeight;
        
                getAfterElement.style.height = getArticleHeight + 120 + 'px';
            }
    
            calcHeightArticle();
            window.addEventListener('resize', calcHeightArticle);
        }
        
    }

    function _customAnimation(){

        let getIdOfCustomAnimation = document.querySelectorAll('#animation-custom');

        function comprobationAnimation(){

            getIdOfCustomAnimation.forEach((data)=>{
                if(data.classList.contains('aos-animate')){
                    setTimeout(()=>{
                        data.nextElementSibling.style.height = "0";
                        data.nextElementSibling.classList.add('active');
                    },500)
                }
            });

        }


        setTimeout(()=>{
            comprobationAnimation();
        },800);

        window.addEventListener('scroll', comprobationAnimation);
        
    }

    function _hondaHome(){

        let getHondaContainer = document.querySelector('#hondaContainer');
        
        if(getHondaContainer){
            let getHondaContainerAfter = document.querySelector('.honda__container__after');
            let getHondaGrey = document.querySelector('#hondaAnimation');
            let getHondaBackground = document.querySelector('#hondaAnimationTwo');
    
    
            getHondaContainerAfter.style.height = getHondaContainer.scrollHeight + "px";
    
            window.addEventListener('scroll', ()=>{
                reuseAnimation();
            });
    
            function reuseAnimation(){
                if(getHondaGrey.classList.contains('aos-animate')){
                    let restaScrollHeight =  getHondaContainer.scrollHeight - getHondaGrey.scrollHeight;
                    getHondaContainerAfter.style.height = restaScrollHeight + "px";
                }
    
                if(getHondaBackground.classList.contains('aos-animate')){
                    getHondaContainerAfter.style.height = "0";
                }
            }
            setTimeout(()=>{
                reuseAnimation();
            },800)
        }

    }

    return {
        setHandleEvent: ()=>{
            try{
                _hondaResponsability()
            }catch(error){ }
            try{
                _backgroundPublications()
            }catch(error){ }
            try{
                _customAnimation()
            }catch(error){ }
            try{
                _hondaHome()
            }catch(error){ }
        }
    }

})();


const loadHondaHandlers = ()=>{
    honda.setHandleEvent()
}


export {
    loadHondaHandlers
}